import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ROUTES } from '../constants';
import './Breadcrumb.css';

const Breadcrumb = () => {
  const location = useLocation();
  
  // Get current project name if on a project page
  const getCurrentProject = () => {
    const currentRoute = ROUTES.find(route => route.path === location.pathname);
    return currentRoute ? currentRoute.name : null;
  };

  const currentProject = getCurrentProject();
  
  // Determine breadcrumb items based on current path
  const getBreadcrumbItems = () => {
    const items = [
      {
        name: 'Agencies',
        url: 'https://www.pa.gov/agencies',
        isExternal: true
      },
      {
        name: 'Office of Transformation & Opportunity',
        url: 'https://www.pa.gov/agencies/oto',
        isExternal: true
      }
    ];

    // Add current page
    if (location.pathname === '/') {
      items.push({
        name: 'PA Permit Fast Track Program',
        url: null,
        isExternal: false
      });
    } else if (location.pathname === '/intake') {
      items.push({
        name: 'Fast Track Intake Form',
        url: null,
        isExternal: false
      });
    } else if (currentProject) {
      items.push({
        name: 'PA Permit Fast Track Program',
        url: '/',
        isExternal: false
      });
      items.push({
        name: currentProject,
        url: null,
        isExternal: false
      });
    }

    return items;
  };

  const breadcrumbItems = getBreadcrumbItems();

  return (
    <nav className="breadcrumb-nav" aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        {breadcrumbItems.map((item, index) => (
          <li key={index} className="breadcrumb-item">
            {index > 0 && <span className="breadcrumb-separator"> &gt; </span>}
            {item.url ? (
              item.isExternal ? (
                <a 
                  href={item.url} 
                  className="breadcrumb-link"
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  {item.name}
                </a>
              ) : (
                <Link to={item.url} className="breadcrumb-link">
                  {item.name}
                </Link>
              )
            ) : (
              <span className="breadcrumb-current">{item.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
